import { withPublicWrapper } from '../../components/public/Wrapper/withPublicWrapper';
import Intro from '../../components/public/Intro/Intro';
import IntroBlock from '../../components/public/Intro/IntroBlock';
import { Col, Button, Divider, Row } from 'antd';
import Link from 'next/link';
import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import Head from 'next/head';
import ExampleLastIntegration from 'components/public/integrations/overview/ExampleLastIntegration';

const Custom = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const title = formatMessage({
    defaultMessage: 'Streamline sales',
    description: 'custom/title',
  });
  return (
    <>
      <Head>
        <title>{`Hitch and Hike - ${title}`}</title>
      </Head>
      <Intro
        title={title}
        image={{ src: '/logo.png', alt: 'logo', width: '1779', height: '1608' }}
        descriptionText={formatMessage({
          defaultMessage: 'Custom solutions',
          description: 'custom/description',
        })}
      />
      <IntroBlock
        type="green-bottom"
        title={formatMessage({
          defaultMessage: 'You want more time?',
          description: 'custom/get-more/title',
        })}
        description={
          <Col>
            <p>
              <FormattedMessage
                defaultMessage="Let's fix this together."
                description="custom/get-more/description/p1"
              />
            </p>
            <p>
              <FormattedMessage
                defaultMessage="We have a proven track record of helping companies in automating their sales pipeline."
                description="custom/get-more/description/p3"
              />
            </p>
            <Divider />
            <p>
              <FormattedMessage
                defaultMessage="By focusing for 100% on sales integrations, we can easily create your custom solution."
                description="custom/get-more/description/p4"
              />
            </p>
            <Row>
              <Col span={24}>
                <Link href={`/contact`}>
                  <Button type="primary" size="large">
                    <FormattedMessage
                      defaultMessage="Let us help you"
                      description="custom/get-more/link/contact"
                    />
                  </Button>
                </Link>
              </Col>
            </Row>
          </Col>
        }
      />
      <IntroBlock
        type="white"
        title={formatMessage({
          defaultMessage: 'Integrate with Shopify',
          description: 'custom/eating-the-world/title',
        })}
        description={
          <>
            <Col span={24}>
              <p>
                {formatMessage({
                  defaultMessage:
                    'We built automations on top of the Shopify API to easily integrate with your custom software and apps.',
                  description: 'custom/eating-the-world/description3',
                })}
              </p>

              <p>
                {formatMessage({
                  defaultMessage:
                    'We create custom virtual assistants that help you automate your workflow.',
                  description: 'custom/eating-the-world/description4',
                })}
              </p>
            </Col>
            <Col span={24}>
              <Link href={`/contact`}>
                <Button type="primary" size="large">
                  <FormattedMessage
                    defaultMessage="Let us help you"
                    description="custom/get-more/link/contact"
                  />
                </Button>
              </Link>
            </Col>
          </>
        }
      />

      <ExampleLastIntegration type="green" />
      <IntroBlock
        type="white"
        title={formatMessage({
          defaultMessage: 'Automate with Teamleader',
          description: 'custom/eating-the-world/title',
        })}
        description={
          <>
            <Col span={24}>
              <p>
                {formatMessage({
                  defaultMessage: 'We built applications on top of the Teamleader API.',
                  description: 'custom/eating-the-world/description3',
                })}
              </p>

              <p>
                {formatMessage({
                  defaultMessage:
                    'Talk to us, you will be suprised by the ease we can provide solutions.',
                  description: 'custom/eating-the-world/description5',
                })}
              </p>
            </Col>
            <Col span={24}>
              <Link href={`/contact`}>
                <Button type="primary" size="large">
                  <FormattedMessage
                    defaultMessage="Let us help you"
                    description="custom/get-more/link/contact"
                  />
                </Button>
              </Link>
            </Col>
          </>
        }
      />
    </>
  );
};

export default withPublicWrapper(Custom);
